import {
  VISIT_NOTES_REQUEST,
  VISIT_NOTES_SUCCESS,
  VISIT_NOTES_FAILURE,
  PROTOCOL_FLAGS_REQUEST,
  PROTOCOL_FLAGS_SUCCESS,
  PROTOCOL_FLAGS_FAILURE,
  CONTROLLED_SUBS_REQUEST,
  CONTROLLED_SUBS_SUCCESS,
  CONTROLLED_SUBS_FAILURE,
  ALERTS_REQUEST,
  ALERTS_SUCCESS,
  ALERTS_FAILURE,
  REVIEW_REQUEST,
  REVIEW_SUCCESS,
  REVIEW_FAILURE,
  CPT_REVIEW_REQUEST,
  CPT_REVIEW_SUCCESS,
  CPT_REVIEW_FAILURE,
  FOLLOW_UP_REQUEST,
  FOLLOW_UP_SUCCESS,
  FOLLOW_UP_FAILURE,
  ALERT_LIMITS_REQUEST,
  ALERT_LIMITS_SUCCESS,
  ALERT_LIMITS_FAILURE,
  ACTIONS_REQUEST,
  ACTIONS_SUCCESS,
  ACTIONS_FAILURE,
  ADD_ACTION_REQUEST,
  ADD_ACTION_SUCCESS,
  ADD_ACTION_FAILURE,
  ENCOUNTERS_REQUEST,
  ENCOUNTERS_SUCCESS,
  ENCOUNTERS_FAILURE,
  BULLETS_REQUEST,
  BULLETS_SUCCESS,
  BULLETS_FAILURE,
  SET_VIEW,
  VISIT_NOTE_REQUEST,
  VISIT_NOTE_SUCCESS,
  VISIT_NOTE_FAILURE,
  ICD_LOOKUP_REQUEST,
  ICD_LOOKUP_SUCCESS,
  ICD_LOOKUP_FAILURE,
  MEDICATIONS_REQUEST,
  MEDICATIONS_SUCCESS,
  MEDICATIONS_FAILURE,
  AUDIT_LOG_REQUEST,
  AUDIT_LOG_SUCCESS,
  AUDIT_LOG_FAILURE,
} from './VisitNotesActions';

const initialState = {
  data: [],
  cptdata: [],
  actions: {},
  encounters: {},
  bullets: {},
  medications: {},
  visitNote: {},
  error: null,
  limits: null,
  isLoading: false,
  isActionSubmitting: false,
  isActionsLoading: false,
  isEncountersLoading: false,
  isBulletsLoading: false,
  isNoteLoading: false,
  lookups: {},
  isICDLookupsLoading: false,
  isMedicationsLoading: false,
  view: null,
  audit: null,
  isAuditLogLoading: false
};

export default function userReducer(
  state = initialState,
  { type, payload, view, meta },
) {
  switch (type) {
    case VISIT_NOTES_REQUEST:
      return { ...state, isLoading: true };
    case VISIT_NOTES_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case VISIT_NOTES_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PROTOCOL_FLAGS_REQUEST:
      return { ...state, isLoading: true };
    case PROTOCOL_FLAGS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case PROTOCOL_FLAGS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CONTROLLED_SUBS_REQUEST:
      return { ...state, isLoading: true };
    case CONTROLLED_SUBS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case CONTROLLED_SUBS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ALERTS_REQUEST:
      return { ...state, isLoading: true };
    case ALERTS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case ALERTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ALERT_LIMITS_REQUEST:
      return { ...state, data: [] };
    case ALERT_LIMITS_SUCCESS:
      return { ...state, limits: payload.data, error: null };
    case ALERT_LIMITS_FAILURE:
      return { ...state, error: payload.error };

    case REVIEW_REQUEST:
      return { ...state, isLoading: true };
    case REVIEW_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case REVIEW_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CPT_REVIEW_REQUEST:
      return { ...state, isLoading: true };
    case CPT_REVIEW_SUCCESS:
      return { ...state, cptdata: payload.data, error: null, isLoading: false };
    case CPT_REVIEW_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case FOLLOW_UP_REQUEST:
      return { ...state, isLoading: true };
    case FOLLOW_UP_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case FOLLOW_UP_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ACTIONS_REQUEST:
      return { ...state, isActionsLoading: true };
    case ACTIONS_SUCCESS:
      return {
        ...state,
        actions: { ...state.actions, [meta.visitNoteID]: payload.data },
        error: false,
        isActionsLoading: false
      };
    case ACTIONS_FAILURE:
      return { ...state, error: payload.error, isActionsLoading: false };

    case ADD_ACTION_REQUEST:
      return { ...state, isActionSubmitting: true };
    case ADD_ACTION_SUCCESS:
      return { ...state, error: null, isActionSubmitting: false };
    case ADD_ACTION_FAILURE:
      return { ...state, error: payload.error, isActionSubmitting: false };

    case ENCOUNTERS_REQUEST:
      return { ...state, isEncountersLoading: true, };
    case ENCOUNTERS_SUCCESS:
      return {
        ...state,
        encounters: { ...state.encounters, [meta.visitNoteID]: payload.data },
        error: false,
        isEncountersLoading: false
      };
    case ENCOUNTERS_FAILURE:
      return { ...state, error: payload.error, isEncountersLoading: false };

    case SET_VIEW:
      return { ...state, view };

    case VISIT_NOTE_REQUEST:
      return { ...state, isNoteLoading: true };
    case VISIT_NOTE_SUCCESS:
      return {
        ...state,
        visitNote: { ...state.visitNote, [meta.visitNoteID]: payload.data },
        error: false,
        isNoteLoading: false
      };
    case VISIT_NOTE_FAILURE:
      return { ...state, error: payload.error, isNoteLoading: false };

    case BULLETS_REQUEST:
      return { ...state, isBulletsLoading: true, };
    case BULLETS_SUCCESS:
      return {
        ...state,
        bullets: { ...state.bullets, [meta.visitNoteID]: payload.data },
        error: false,
        isBulletsLoading: false
      };
    case BULLETS_FAILURE:
      return { ...state, error: payload.error, isBulletsLoading: false };

      case ICD_LOOKUP_REQUEST:
        return { ...state, isICDLookupsLoading: true, };
      case ICD_LOOKUP_SUCCESS:
        return {
          ...state,
          lookups: { icd: payload.data },
          error: false,
          isICDLookupsLoading: false
        };
      case ICD_LOOKUP_FAILURE:
        return { ...state, error: payload.error, isICDLookupsLoading: false };

      case MEDICATIONS_REQUEST:
        return { ...state, isMedicationsLoading: true, };
      case MEDICATIONS_SUCCESS:
        return {
          ...state,
          medications: { ...state.medications, [meta.visitNoteID]: payload.data ? payload.data : {} },
          error: false,
          isMedicationsLoading: false
        };
      case MEDICATIONS_FAILURE:
        return { ...state, error: payload.error, isMedicationsLoading: false };

      case AUDIT_LOG_REQUEST:
        return { ...state, isAuditLogLoading: true, };
      case AUDIT_LOG_SUCCESS:
        return {
          ...state,
          audit: payload.data,
          error: false,
          isAuditLogLoading: false
        };
      case AUDIT_LOG_FAILURE:
        return { ...state, error: payload.error, isAuditLogLoading: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/visit-notes/VisitNotesReducer.js